import { Link,Outlet } from "react-router-dom";

export function Navigation (){
return(<>
    <div style={{display:"flex",backgroundColor:"#0066ff",padding:"10px"}}>
     <div style={{marginRight:"10px", fontFamily:"sans-serif",cursor:"pointer",}}><Link to="/Home" style={{textDecoration:"none",color:"black"}} ><span>Home</span></Link></div>
     <div style={{marginRight:"10px", fontFamily:"sans-serif",cursor:"pointer",}}><Link to="/Contact us" style={{textDecoration:"none",color:"black"}}><span>Contact us</span></Link></div>
    </div>

    <Outlet />
     </>
    )

}